/** @format */

module.exports = {
  publicKey: "5a43ce9e01324c91888c4d615492ac23",
  hostnameId: "betchan",
};



// WEBPACK FOOTER //
// ./src/partners/config/partner.js